import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicFormsService } from './services/dynamic-forms/dynamic-forms.service';
import { DynamicFormsResolver } from './services/dynamic-forms/dynamic-forms.resolver';
import { BaseInputDirective } from './dynamic-form-inputs/base-input.directive';
import { TextInputComponent } from './dynamic-form-inputs/text-input/text-input.component';
import { GenericInputComponent } from './dynamic-form-inputs/generic-input/generic-input.component';
import { SelectInputComponent } from './dynamic-form-inputs/select-input/select-input.component';
import { DynamicFormLoadDirective } from './directives/dynamic-form-structural.directive';
import { DateInputComponent } from './dynamic-form-inputs/date-input/date-input.component';
import { NumberInputComponent } from './dynamic-form-inputs/number-input/number-input.component';
import { CurrencyInputComponent } from './dynamic-form-inputs/currency-input/currency-input.component';
import { TextAreaInputComponent } from './dynamic-form-inputs/text-area-input/text-area-input.component';
import { EmailInputComponent } from './dynamic-form-inputs/email-input/email-input.component';
import { PasswordInputComponent } from './dynamic-form-inputs/password-input/password-input.component';
import { ToggleInputComponent } from './dynamic-form-inputs/toggle-input/toggle-input.component';
import { RadioInputComponent } from './dynamic-form-inputs/radio-input/radio-input.component';
import { CheckboxInputComponent } from './dynamic-form-inputs/checkbox-input/checkbox-input.component';
//import { NgxMaskModule } from 'ngx-mask';
import { DisabledInputComponent } from './dynamic-form-inputs/disabled-input/disabled-input.component';
import { SsnInputComponent } from './dynamic-form-inputs/ssn-input/ssn-input.component';
import { MaterialModule } from '../material/material.module';
import { DialogModule } from '../dialog/dialog.module';
import { RouterModule } from '@angular/router';
import { TimeInputComponent } from './dynamic-form-inputs/time-input/time-input.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TwoListInputComponent } from './dynamic-form-inputs/two-list-input/two-list-input.component';
import { UtilityModule } from '../utility/utility.module';
import { AutoCompleteInputComponent } from './dynamic-form-inputs/autocomplete-input/autocomplete-input.component';
import { PostalCodePrepopulateComponent } from './dynamic-form-inputs/postal-code-prepopulate/postal-code-prepopulate.component';
import { PostalCodePrepopulateService } from './dynamic-form-inputs/postal-code-prepopulate/postal-code-prepopulate.service';
import { PhoneInputComponent } from './dynamic-form-inputs/phone-input/phone-input.component';
import { InternationalPhonePrefixInputComponent } from './dynamic-form-inputs/international-phone-prefix-input/international-phone-prefix-input.component';
import { ErrorInputComponent } from './dynamic-form-inputs/error-input/error-input.component';
import { LookupInputComponent } from './dynamic-form-inputs/lookup-input/lookup-input.component';
import { InnerLookupComponent } from './dynamic-form-inputs/lookup-input/inner-lookup-component/inner-lookup.component';
import { ActiveDirectoryTypeaheadComponent } from './dynamic-form-inputs/active-directory-typeahead/active-directory-typeahead.component';
import { MultipleCheckboxInputComponent } from './dynamic-form-inputs/multiple-checkbox-input/multiple-checkbox-input.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    DialogModule,
    RouterModule,
    MatTooltipModule,
    UtilityModule,
    TextInputComponent,
    SelectInputComponent,
    DynamicFormLoadDirective,
    CheckboxInputComponent,
    DateInputComponent,
    NumberInputComponent,
    CurrencyInputComponent,
    TextAreaInputComponent,
    EmailInputComponent,
    PasswordInputComponent,
    ToggleInputComponent,
    RadioInputComponent,
    DisabledInputComponent,
    SsnInputComponent,
    TimeInputComponent,
    TwoListInputComponent,
    AutoCompleteInputComponent,
    ActiveDirectoryTypeaheadComponent,
    PostalCodePrepopulateComponent,
    PhoneInputComponent,
    InternationalPhonePrefixInputComponent,
    ErrorInputComponent,
    LookupInputComponent,
    InnerLookupComponent,
    MultipleCheckboxInputComponent,
    BaseInputDirective,
    GenericInputComponent,
  ],
  exports: [
    ReactiveFormsModule,
    TextInputComponent,
    GenericInputComponent,
    SelectInputComponent,
    CheckboxInputComponent,
    DateInputComponent,
    NumberInputComponent,
    FormsModule,
    DynamicFormLoadDirective,
    CurrencyInputComponent,
    TextAreaInputComponent,
    EmailInputComponent,
    PasswordInputComponent,
    ToggleInputComponent,
    DisabledInputComponent,
    RadioInputComponent,
    SsnInputComponent,
    TwoListInputComponent,
    AutoCompleteInputComponent,
    ActiveDirectoryTypeaheadComponent,
    PostalCodePrepopulateComponent,
    PhoneInputComponent,
    InternationalPhonePrefixInputComponent,
    ErrorInputComponent,
    LookupInputComponent,
    MultipleCheckboxInputComponent,
  ],
  providers: [DynamicFormsService, DynamicFormsResolver, PostalCodePrepopulateService],
})
export class DynamicFormsModule {}
